<template>
  <div class="property-list bg-white">
    <div class="container-fluid">
      <sidebar />
      <div v-if="deleteMsg">{{statusAlert(true)}}</div>
      <div class="col-md-9 col-lg-10 ml-md-auto py-4">
        <div class="header d-flex justify-content-between w-100 align-items-center py-3 mb-3 border-bottom border-dark">
          <h2 class="m-0" v-html="$t(`${$route.params.type}-property`)"></h2>
          <router-link :to="{ name: 'Add New Property', params: { type: $route.params.type }}">
            <b-button class="px-4 py-2" variant="primary">新規追加</b-button>
          </router-link>
        </div>
        <propertyList v-bind:properties="properties" v-bind:property-type="$route.params.type" v-if="properties"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import sidebar from '@/components/_sidebar/sidebar'
import propertyList from './components/propertyList'

export default {
  data () {
    return {
      rows: 8,
      perPage: 1,
      currentPage: 1
    }
  },
  created () {
    this.getAllProperties({ type: this.$route.params.type, apiType: 'admin' })
  },
  computed: {
    ...mapState('adminProperty', ['properties', 'deleteMsg'])
  },
  methods: {
    ...mapActions('adminProperty', ['getAllProperties']),
    filterBySubject: function (data) {
      return (data.subject === 'administrator_accounts')
    },
    statusAlert (append = false) {
      this.$bvToast.toast('body', {
        title: this.deleteMsg,
        toaster: 'b-toaster-top-center',
        solid: true,
        appendToast: append,
        autoHideDelay: 3000
      })
    }
  },
  components: {
    sidebar,
    propertyList
  }
}
</script>
